import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell
} from 'recharts';
import {
  Users, UserCheck, AlertTriangle, Building2, Star, PowerOff,
  Menu, X, LayoutDashboard, Package, DoorOpen, MessageSquare,
  BarChart2, Vote, Settings, Copy, Map, Share2, Shield, FileSpreadsheet,
  ChevronRight
} from 'lucide-react';
import logo from '../../logo.png';

const COLORS = ['#16a34a', '#9b1c35', '#0ea5e9', '#f59e0b', '#64748b'];

// ─────────────────────────────────────────────────────────────
// CONFIGURACIÓN DE MENÚS POR ROL
// ─────────────────────────────────────────────────────────────
const MENUS_POR_ROL = {
  superadmin: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Banco Talento',      path: '/talento',            icon: Star,            cat: 'operacion' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Auditoría',          path: '/auditoria',          icon: Shield,          cat: 'analisis' },
    { label: 'Organigrama',        path: '/organigrama',        icon: Share2,          cat: 'admin' },
    { label: 'Validación Excel',   path: '/validacion',         icon: FileSpreadsheet, cat: 'analisis' },
    { label: 'Admin',              path: '/admin',              icon: Settings,        cat: 'admin' },
  ],
  coordinador_general: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Banco Talento',      path: '/talento',            icon: Star,            cat: 'operacion' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Auditoría',          path: '/auditoria',          icon: Shield,          cat: 'analisis' },
    { label: 'Organigrama',        path: '/organigrama',        icon: Share2,          cat: 'admin' },
    { label: 'Validación Excel',   path: '/validacion',         icon: FileSpreadsheet, cat: 'analisis' },
    { label: 'Admin',              path: '/admin',              icon: Settings,        cat: 'admin' },
  ],
  coordinador_territorial: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Mis Promovidos',     path: '/mis-promovidos',     icon: UserCheck,       cat: 'operacion' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  coordinador_sectorial: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Mis Promovidos',     path: '/mis-promovidos',     icon: UserCheck,       cat: 'operacion' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  seccional: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin',     descripcion: 'Gestión de tu gente' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion', descripcion: 'Visitas domiciliarias y capturas' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis',  descripcion: 'Revisión de registros duplicados' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion', descripcion: 'Control del día de la elección' },
  ],
  operador: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin',     descripcion: 'Gestión de tu gente' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion', descripcion: 'Visitas domiciliarias y capturas' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion', descripcion: 'Control del día de la elección' },
  ],
  promotor: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion', descripcion: 'Visitas domiciliarias y capturas' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion', descripcion: 'Control del día de la elección' },
  ],
  auditor: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion', descripcion: 'Visitas domiciliarias y capturas' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis',  descripcion: 'Revisión de registros duplicados' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion', descripcion: 'Control del día de la elección' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
  ],
  responsable_inventario: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion', descripcion: 'Control de materiales' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
  ],
  movilizador: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion', descripcion: 'Control del día de la elección' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion', descripcion: 'Mapa de visitas y evidencias' },
  ],
  representante_casilla: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal', descripcion: 'Panel principal' },
    { label: 'Mi Casilla',         path: '/mi-casilla',         icon: Vote,            cat: 'operacion', descripcion: 'Marcar votos de tu casilla' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion', descripcion: 'Campañas de mensajes' },
  ],
};

const ROLES_DASHBOARD = [
  'superadmin',
  'coordinador_general',
  'coordinador_territorial',
  'coordinador_sectorial',
];

const CATEGORIAS = [
  { key: 'principal', label: 'Principal' },
  { key: 'operacion', label: 'Operación' },
  { key: 'analisis',  label: 'Análisis' },
  { key: 'admin',     label: 'Administración' },
];

const COLORES_MODULOS = {
  '/toca':               { bg: 'bg-verde-500',    },
  '/cobertura':          { bg: 'bg-sky-500',      },
  '/duplicidades':       { bg: 'bg-amber-500',    },
  '/talento':            { bg: 'bg-yellow-500',   },
  '/inventario':         { bg: 'bg-violet-500',   },
  '/mensajeria':         { bg: 'bg-guinda-600',   },
  '/reportes-avanzados': { bg: 'bg-indigo-500',   },
  '/movilizacion':       { bg: 'bg-rose-500',     },
  '/auditoria':          { bg: 'bg-slate-600',    },
  '/organigrama':        { bg: 'bg-teal-500',     },
  '/validacion':         { bg: 'bg-cyan-500',     },
  '/admin':              { bg: 'bg-slate-700',    },
  '/usuarios':           { bg: 'bg-blue-500',     },
  '/mis-promovidos':     { bg: 'bg-emerald-500',  },
  '/mi-casilla':         { bg: 'bg-purple-500',   },
  '/dashboard':          { bg: 'bg-guinda-600',   },
};
const COLORES_DEFAULT = { bg: 'bg-slate-500' };

// ─────────────────────────────────────────────────────────────
// SIDEBAR
// ─────────────────────────────────────────────────────────────
function Sidebar({ isOpen, onClose, user, navItems, rol, location, onNav, onLogout }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex animate-fade-in"
      onClick={onClose}>
      <aside className="w-full max-w-sm h-full flex flex-col shadow-2xl animate-slide-in bg-guinda-900"
        onClick={e => e.stopPropagation()}>

        {/* Header sidebar */}
        <div className="flex items-center justify-between px-5 py-5 border-b border-white/10">
          <img src={logo} alt="DOMINIUM" className="h-14 object-contain drop-shadow-[0_2px_10px_rgba(255,255,255,0.45)]" />
          <button onClick={onClose}
            className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition text-white">
            <X size={20} />
          </button>
        </div>

        {/* Info usuario */}
        <div className="px-5 py-4 border-b border-white/10 flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-gradient-to-br from-guinda-400 to-guinda-700 flex items-center justify-center text-white font-bold text-base flex-shrink-0 ring-2 ring-white/20">
            {user?.nombre?.[0]?.toUpperCase() || 'U'}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-white font-semibold text-sm truncate">{user?.nombre} {user?.apellido_paterno}</p>
            <p className="text-guinda-200 text-xs capitalize truncate">{rol.replace(/_/g, ' ')}</p>
          </div>
        </div>

        {/* Módulos agrupados */}
        <nav className="flex-1 px-3 py-4 overflow-y-auto">
          {CATEGORIAS.map(cat => {
            const items = navItems.filter(i => i.cat === cat.key);
            if (items.length === 0) return null;
            return (
              <div key={cat.key} className="mb-5">
                <p className="px-3 mb-2 text-[10px] font-bold text-white/40 uppercase tracking-widest">
                  {cat.label}
                </p>
                <div className="flex flex-col gap-1">
                  {items.map(item => {
                    const isActive = location.pathname === item.path;
                    const Icon = item.icon;
                    return (
                      <button key={item.path} onClick={() => onNav(item.path)}
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-left text-sm font-medium transition-all ${
                          isActive
                            ? 'bg-white text-guinda-800 shadow-lg'
                            : 'text-white/85 hover:bg-white/10 hover:text-white'
                        }`}>
                        <Icon size={18} className={isActive ? 'text-guinda-700' : 'text-white/70'} />
                        <span className="flex-1 truncate">{item.label}</span>
                        {isActive && <ChevronRight size={14} className="text-guinda-700" />}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="px-3 py-4 border-t border-white/10">
          <button onClick={onLogout}
            className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-white/80 hover:bg-red-500/20 hover:text-white transition w-full text-sm font-medium">
            <PowerOff size={16} />
            Cerrar sesión
          </button>
        </div>
      </aside>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// MENÚ OPERATIVO (roles operativos)
// ─────────────────────────────────────────────────────────────
function MenuOperativo({ user, menus, navigate, logout }) {
  const saludos = {
    seccional:               'Seccional',
    operador:                'Operador',
    promotor:                'Promotor',
    auditor:                 'Auditor',
    responsable_inventario:  'Resp. de Inventario',
    movilizador:             'Movilizador',
    representante_casilla:   'Representante de Casilla',
  };

  const modulosVisibles = menus.filter(m => m.path !== '/dashboard');

  return (
    <div className="min-h-screen bg-ink-50 flex flex-col">
      {/* Header */}
      <header className="bg-guinda-900 text-white px-4 py-3 flex items-center justify-between shadow-lg sticky top-0 z-40">
        <img src={logo} alt="DOMINIUM" className="h-10 object-contain drop-shadow-[0_2px_10px_rgba(255,255,255,0.5)]" />
        <div className="flex items-center gap-2">
          <div className="text-right hidden sm:block">
            <p className="font-semibold text-xs leading-tight">{user?.nombre} {user?.apellido_paterno}</p>
            <p className="text-guinda-200 text-[10px] capitalize">{saludos[user?.rol] || user?.rol}</p>
          </div>
          <div className="w-9 h-9 rounded-full bg-white/15 ring-2 ring-white/20 flex items-center justify-center text-white font-bold text-sm">
            {user?.nombre?.[0]?.toUpperCase() || 'U'}
          </div>
          <button onClick={logout} title="Cerrar sesión"
            className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition">
            <PowerOff size={16} />
          </button>
        </div>
      </header>

      <main className="flex-1 p-4 md:p-6 max-w-5xl mx-auto w-full">
        <div className="mb-6 mt-2 animate-fade-in-up">
          <h2 className="text-2xl md:text-3xl font-bold text-ink-900">Hola, {user?.nombre} 👋</h2>
          <p className="text-ink-500 text-sm mt-1">¿Qué necesitas hacer hoy?</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {modulosVisibles.map((item, i) => {
            const Icon = item.icon;
            const color = COLORES_MODULOS[item.path] || COLORES_DEFAULT;
            return (
              <button key={item.path} onClick={() => navigate(item.path)}
                className="group bg-white rounded-2xl shadow-soft hover:shadow-lift transition-all duration-300 cursor-pointer p-5 border border-ink-100 text-left hover:-translate-y-1 animate-fade-in-up"
                style={{ animationDelay: `${i * 40}ms` }}>

                <div className="flex items-start justify-between mb-4">
                  <div className={`w-14 h-14 rounded-2xl ${color.bg} flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300`}>
                    <Icon size={26} className="text-white" strokeWidth={1.8} />
                  </div>
                  <ChevronRight size={20} className="text-ink-300 group-hover:text-ink-600 group-hover:translate-x-1 transition-all" />
                </div>

                <h3 className="text-base font-bold text-ink-900 mb-1">{item.label}</h3>
                <p className="text-sm text-ink-500 leading-snug">{item.descripcion || 'Acceder al módulo'}</p>
              </button>
            );
          })}
        </div>

        <p className="text-center text-ink-300 text-xs mt-10">
          DOMINIUM © 2026 — Zacatlán, Puebla · GARCOR Design
        </p>
      </main>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// DASHBOARD EJECUTIVO
// ─────────────────────────────────────────────────────────────
function DashboardEjecutivo({ data, navigate, user, rol }) {
  const { metricas, graficas, capturas_recientes } = data;

  const tarjetas = [
    { titulo: 'Capturas',      valor: metricas.total_promovidos,  icono: Users,         color: 'bg-blue-500'   },
    { titulo: 'Simpatizantes', valor: metricas.total_seguros,     icono: UserCheck,     color: 'bg-verde-500'  },
    { titulo: 'Duplicidades',  valor: metricas.total_duplicidades, icono: AlertTriangle, color: 'bg-amber-500' },
    { titulo: 'Estructuras',   valor: metricas.total_estructuras,  icono: Building2,     color: 'bg-violet-500' },
    { titulo: 'Talento',       valor: metricas.total_talento,      icono: Star,          color: 'bg-yellow-500' },
    { titulo: 'Usuarios',      valor: metricas.total_usuarios,     icono: Users,         color: 'bg-guinda-500' },
  ];

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto w-full">

      {/* Bienvenida */}
      <div className="mb-5 animate-fade-in-up">
        <h2 className="text-xl md:text-2xl font-bold text-ink-900">Tablero Ejecutivo</h2>
        <p className="text-ink-500 text-xs md:text-sm mt-1 capitalize">Bienvenido, {user?.nombre} · {rol.replace(/_/g, ' ')}</p>
      </div>

      {/* Botones de acción rápida — full width en móvil */}
      <div className="mb-5 flex flex-col sm:flex-row flex-wrap gap-2 animate-fade-in-up">
        <button onClick={() => navigate('/toca')}
          className="text-white font-semibold px-5 py-3 rounded-xl hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2 bg-guinda-700 hover:bg-guinda-800">
          <DoorOpen size={18} /> Toca y Promueve
        </button>
        <button onClick={() => navigate('/cobertura')}
          className="text-white font-semibold px-5 py-3 rounded-xl hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2 bg-verde-600 hover:bg-verde-700">
          <Map size={18} /> Cobertura en Campo
        </button>
      </div>

      {/* KPIs — 2 col en móvil, 3 en tablet, 6 en desktop */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5 md:gap-3 mb-5">
        {tarjetas.map((t, i) => (
          <div key={i}
            className="bg-white rounded-xl md:rounded-2xl shadow-soft p-3 md:p-4 border border-ink-100 hover:shadow-lift transition-all animate-fade-in-up"
            style={{ animationDelay: `${i * 50}ms` }}>
            <div className={`w-9 h-9 md:w-10 md:h-10 ${t.color} rounded-xl flex items-center justify-center mb-2.5 md:mb-3 shadow-sm`}>
              <t.icono size={18} className="text-white" strokeWidth={2} />
            </div>
            <p className="text-xl md:text-2xl font-bold text-ink-900 leading-none">{t.valor?.toLocaleString('es-MX') ?? 0}</p>
            <p className="text-[11px] md:text-xs text-ink-500 mt-1.5 leading-tight">{t.titulo}</p>
          </div>
        ))}
      </div>

      {/* Gráfica de barras */}
      <div className="bg-white rounded-xl md:rounded-2xl shadow-soft p-4 md:p-6 mb-4 border border-ink-100">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1.5 h-5 rounded-full bg-guinda-700"></div>
          <h3 className="font-bold text-ink-900 text-sm md:text-base">Promovidos por Sección</h3>
        </div>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={graficas.por_seccion}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="numero_seccion" tick={{ fontSize: 10, fill: '#64748b' }} axisLine={{ stroke: '#e2e8f0' }} />
            <YAxis tick={{ fontSize: 10, fill: '#64748b' }} axisLine={{ stroke: '#e2e8f0' }} />
            <Tooltip
              contentStyle={{ borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 12px rgba(15,23,42,0.08)' }}
            />
            <Bar dataKey="promovidos_activos" fill="#9b1c35" name="Promovidos" radius={[6, 6, 0, 0]} />
            <Bar dataKey="meta_votos" fill="#e2e8f0" name="Meta" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Nivel de apoyo */}
      <div className="bg-white rounded-xl md:rounded-2xl shadow-soft p-4 md:p-6 mb-5 border border-ink-100">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1.5 h-5 rounded-full bg-verde-600"></div>
          <h3 className="font-bold text-ink-900 text-sm md:text-base">Nivel de Apoyo</h3>
        </div>
        {(() => {
          const datosNivel = graficas.por_nivel_apoyo.map(item => ({ ...item, total: parseInt(item.total) }));
          const totalGeneral = datosNivel.reduce((sum, item) => sum + item.total, 0);
          const labels = {
            'seguro': 'Seguro',
            'simpatizante': 'Simpatizante',
            'defensa_del_voto': 'Defensa del Voto',
            'indeciso': 'Indeciso',
            'oposicion': 'Oposición',
            'no_definido': 'No definido'
          };
          return (
            <div className="flex flex-col md:flex-row items-center gap-5">
              <div className="relative flex-shrink-0" style={{ width: 180, height: 180 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={datosNivel} dataKey="total" nameKey="nivel_apoyo"
                      cx="50%" cy="50%" innerRadius={55} outerRadius={80}
                      paddingAngle={3}
                    >
                      {datosNivel.map((_, index) => (
                        <Cell key={index} fill={COLORS[index % COLORS.length]} stroke="none" />
                      ))}
                    </Pie>
                    <Tooltip
                      formatter={(value, name) => [value, labels[name] || name]}
                      contentStyle={{ borderRadius: '12px', border: '1px solid #e2e8f0' }}
                    />
                  </PieChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                  <span className="text-2xl md:text-3xl font-bold text-ink-900">{totalGeneral.toLocaleString('es-MX')}</span>
                  <span className="text-[9px] font-semibold text-ink-400 tracking-wider">TOTAL</span>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 justify-center flex-1 w-full">
                {datosNivel.map((item, index) => (
                  <div key={index} className="flex items-center gap-2.5 text-xs md:text-sm bg-ink-50 px-3 py-2 rounded-xl">
                    <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: COLORS[index % COLORS.length] }} />
                    <span className="font-bold text-ink-900">{item.total.toLocaleString('es-MX')}</span>
                    <span className="text-ink-500 truncate">{labels[item.nivel_apoyo] || item.nivel_apoyo}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}
      </div>

      {/* Capturas recientes — Cards en móvil, tabla en desktop */}
      <div className="bg-white rounded-xl md:rounded-2xl shadow-soft p-4 md:p-6 border border-ink-100">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1.5 h-5 rounded-full bg-guinda-700"></div>
          <h3 className="font-bold text-ink-900 text-sm md:text-base">Capturas Recientes</h3>
        </div>

        {/* Mobile: cards */}
        <div className="md:hidden space-y-2">
          {capturas_recientes.map((c, i) => (
            <div key={i} className="bg-ink-50 rounded-xl p-3 border border-ink-100">
              <div className="flex items-start justify-between gap-2 mb-2">
                <p className="font-semibold text-ink-900 text-sm leading-tight">{c.persona}</p>
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold flex-shrink-0 ${
                  c.estatus_captura === 'pendiente' ? 'bg-amber-100 text-amber-700' : 'bg-verde-100 text-verde-700'
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full ${c.estatus_captura === 'pendiente' ? 'bg-amber-500' : 'bg-verde-600'}`}></span>
                  {c.estatus_captura}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-1 text-[11px] text-ink-600">
                <span>📞 {c.telefono_principal}</span>
                <span>📍 Sec. {c.numero_seccion}</span>
                <span className="col-span-2">🏛 {c.nombre_estructura}</span>
                <span className="col-span-2">👤 {c.capturado_por}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: tabla */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-ink-100">
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Persona</th>
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Teléfono</th>
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Sección</th>
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Estructura</th>
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Capturado por</th>
                <th className="text-left py-2.5 px-3 text-ink-500 font-semibold text-xs uppercase tracking-wide">Estatus</th>
              </tr>
            </thead>
            <tbody>
              {capturas_recientes.map((c, i) => (
                <tr key={i} className="border-b border-ink-50 hover:bg-ink-50/50 transition">
                  <td className="py-3 px-3 font-semibold text-ink-800 text-sm">{c.persona}</td>
                  <td className="py-3 px-3 text-ink-600 text-sm">{c.telefono_principal}</td>
                  <td className="py-3 px-3 text-ink-600 text-sm">{c.numero_seccion}</td>
                  <td className="py-3 px-3 text-ink-600 text-sm">{c.nombre_estructura}</td>
                  <td className="py-3 px-3 text-ink-600 text-sm">{c.capturado_por}</td>
                  <td className="py-3 px-3">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${
                      c.estatus_captura === 'pendiente' ? 'bg-amber-100 text-amber-700' : 'bg-verde-100 text-verde-700'
                    }`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${c.estatus_captura === 'pendiente' ? 'bg-amber-500' : 'bg-verde-600'}`}></span>
                      {c.estatus_captura}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <p className="text-center text-ink-300 text-xs mt-8">
        DOMINIUM © 2026 — Zacatlán, Puebla · GARCOR Design
      </p>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────
// COMPONENTE PRINCIPAL
// ─────────────────────────────────────────────────────────────
export default function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const rol = user?.rol || 'promotor';
  const esDashboardCompleto = ROLES_DASHBOARD.includes(rol);
  const navItems = MENUS_POR_ROL[rol] || MENUS_POR_ROL['promotor'];

  useEffect(() => {
    if (esDashboardCompleto) {
      api.get('/dashboard')
        .then(res => setData(res.data))
        .catch(err => console.error(err))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [esDashboardCompleto]);

  const handleNav = (path) => {
    setSidebarOpen(false);
    navigate(path);
  };

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-ink-50">
      <div className="text-center animate-fade-in">
        <div className="w-14 h-14 border-4 border-guinda-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-ink-500 font-medium">Cargando DOMINIUM...</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-ink-50 flex flex-col">
      {/* Header */}
      {esDashboardCompleto && (
        <header className="bg-guinda-900 text-white px-3 md:px-4 py-2.5 md:py-3 flex items-center justify-between shadow-lg sticky top-0 z-40">
          <div className="flex items-center gap-4">
            <button onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition">
              <Menu size={20} />
            </button>
            <img src={logo} alt="DOMINIUM" className="h-10 md:h-12 object-contain drop-shadow-[0_2px_10px_rgba(255,255,255,0.5)]" />
          </div>
          <div className="flex items-center gap-2 md:gap-3">
            <div className="text-right hidden sm:block">
              <p className="font-semibold text-xs md:text-sm leading-tight">{user?.nombre} {user?.apellido_paterno}</p>
              <p className="text-guinda-200 text-[10px] md:text-xs capitalize">{rol.replace(/_/g, ' ')}</p>
            </div>
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-guinda-500 to-guinda-800 ring-2 ring-white/20 flex items-center justify-center text-white font-bold text-xs md:text-sm">
              {user?.nombre?.[0]?.toUpperCase() || 'U'}
            </div>
            <button onClick={logout} title="Cerrar sesión"
              className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition">
              <PowerOff size={16} />
            </button>
          </div>
        </header>
      )}

      {/* Sidebar */}
      {esDashboardCompleto && (
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          user={user}
          navItems={navItems}
          rol={rol}
          location={location}
          onNav={handleNav}
          onLogout={logout}
        />
      )}

      {/* Contenido */}
      {esDashboardCompleto && data ? (
        <DashboardEjecutivo data={data} navigate={navigate} user={user} rol={rol} />
      ) : !esDashboardCompleto ? (
        <MenuOperativo user={user} menus={navItems} navigate={navigate} logout={logout} />
      ) : null}
    </div>
  );
}
